<template>
  <LoadingData v-if="isLoadingData" />
  <iframe v-else :src="report.url" width="100%" height="100%" frameborder="0" />
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import PATHS from '@/router/routesMap'

export default {
  name: 'Report',

  components: {
    LoadingData,
  },

  data() {
    return {
      hash: this.$route.params.hash,
      isLoadingData: true,
      report: null,
    }
  },

  watch: {
    '$route.params.hash': function (newHash) {
      this.hash = newHash

      this.isLoadingData = true

      setTimeout(() => {
        this.getReportByHash()
      }, 1000)
    },
  },

  methods: {
    async getReportByHash() {
      try {
        this.report = await this.$store.dispatch('getReportByHash', {
          hash: this.hash,
        })

        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$router.push(PATHS.HOME)
      }
    },
  },

  mounted() {
    this.getReportByHash()
  },
}
</script>
